module.exports = __webpack_public_path__ + "media/img/payment-methods/diners-9c0e22fbaa1d27e3776de0d0a1f9c253.svg";